import { mapState } from "vuex";

import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import { Component, Watch } from "@/decorators";
import PaginationModel from "@/models/paginationModel";
import EtapaPCPModel from "@/models/pcp/etapaPCPModel";
import UsuarioModel from "@/models/usuarioModel";
import EtapaPCPService from "@/services/etapaPCPService";
import { AppState, SessionActions } from "@/store/store";
import Bus from "@/utils/events/bus";

import DashboardComponent from "./dashboardComponent";

// Precisa ser assim se não ocorre erro
// eslint-disable-next-line @typescript-eslint/no-var-requires
const echarts = require("echarts");

import "./dashboardComponent.scss";

@Component({
    components: {
        dateTimePickerComponent,
        comboComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
    },
})
export default class ProducaoPCP extends DashboardComponent {
    // State computed props
    usuarioLogado: UsuarioModel;

    private graficoProducaoPCPPorHoraByEtapa: any;

    etapaOptions: Array<Object> = [];
    etapaId = 0;

    private dataEtapa = new Date();

    private graphStyle = {
        width: "100%",
        height: "300px",
        margin: "25px 0px 0px 0px",
        // @ts-ignore
        zoom: this.compensarZoomGrafico(document.body.style.zoom),
    };

    private async mounted() {
        await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);
        Bus.$emit("hide-nav-menu", false);

        //@ts-ignore
        this.graficoProducaoPCPPorHoraByEtapa = echarts.init(this.$refs.producaoPorHoraByEtapaPCP);

        const etapas = await new EtapaPCPService()
            .combo(true)
            .withLoading()
            .resolveWithJSON<PaginationModel<EtapaPCPModel>>();
        this.etapaOptions = etapas.list.map(item => ({ value: item.id, text: item.descricao }));

        this.setGraficos([this.graficoProducaoPCPPorHoraByEtapa]);

        this.updateDashboard();
    }

    protected async updateDashboard() {
        this.showLoadingGraficos();

        const response = await this.service.getManipulacoesPorHoraByEtapa(this.dataEtapa, this.etapaId);

        this.graficoProducaoPCPPorHoraByEtapa.setOption(
            this.getOpcoesGrafico({
                titulo: this.$t("__.ts.dashboardProducaoPCP") as string,
                labels: response.map(d => d.label),
                dados: response.map(d => d.valor),
                tipoGrafico: "line",
                format: "<b>{b}</b><br/>{c}",
                nomeSerie: response.map(d => d.serie)[0],
            }),
        );

        this.hideLoadingGraficos();
    }

    protected convertToString(numero: number) {
        return numero == null ? "0" : numero.toString();
    }

    @Watch("dataEtapa")
    @Watch("etapaId")
    private onDataInicial() {
        if (this.etapaId > 0 && this.dataEtapa != null) {
            this.updateDashboard();
        }
    }
}
